// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file.

console.log(
	'%c This site was designed & developed by https://www.sleeplessmedia.com',
	'background:#000; color: #ae956e; padding: 10px 15px; font-size: 13px; font-weight: 500; width: 100%;'
);

// Cookies functions
function setCookie(cookieName, cookieValue) {
	var today = new Date();
	var expire = new Date();
	expire.setTime(today.getTime() + 3600000 * 24 * 7);
	document.cookie =
		cookieName +
		'=' +
		encodeURI(cookieValue) +
		';expires=' +
		expire.toGMTString();
}

function getCookie(cname) {
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}
// Boost SD - Smooth image hover transition
(function () {
    function applyHover(link) {
        if (link.dataset.hoverInit) return;
        link.dataset.hoverInit = 'true';

        var mainImg = link.querySelector('.boost-sd__product-image-img--main');
        var secondImg = link.querySelector('.boost-sd__product-image-img--second');

        if (!mainImg || !secondImg) return;

        // Set wrapper styles
        link.style.cssText += 'display:block !important; position:relative !important; overflow:hidden !important;';

        // Style both images
        var imgStyle = [
            'position:absolute',
            'top:0',
            'left:0',
            'width:100%',
            'height:100%',
            'object-fit:cover',
            'transition:opacity 0.5s ease'
        ].join('!important;') + '!important;';

        mainImg.style.cssText += imgStyle;
        secondImg.style.cssText += imgStyle;

        // Set initial opacity
        mainImg.style.setProperty('opacity', '1', 'important');
        secondImg.style.setProperty('opacity', '0', 'important');

        // Add a spacer so the <a> tag has height (since both imgs are absolute)
        if (!link.querySelector('.boost-hover-spacer')) {
            var spacer = document.createElement('span');
            spacer.className = 'boost-hover-spacer';
            spacer.style.cssText = 'display:block;width:100%;padding-top:100%;';
            link.insertBefore(spacer, link.firstChild);
        }

        link.addEventListener('mouseenter', function () {
            mainImg.style.setProperty('opacity', '0', 'important');
            secondImg.style.setProperty('opacity', '1', 'important');
        });

        link.addEventListener('mouseleave', function () {
            mainImg.style.setProperty('opacity', '1', 'important');
            secondImg.style.setProperty('opacity', '0', 'important');
        });
    }

    function initAll() {
        document.querySelectorAll('.boost-sd__product-link.boost-sd__product-image').forEach(applyHover);
    }

    // Observe body for Boost SD rendering products dynamically
    new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('DOMContentLoaded', initAll);
    window.addEventListener('load', initAll);
})();